"use client";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdInfo } from "react-icons/md";
import "./NewOrder.css";

const NewOrder = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // Hardcoded products
  const hardcodedProducts = [
    {
      id: "1",
      name: "Ultratech",
      category: "Cement",
      img: "/Images/ultratech.png",
    },
    {
      id: "2",
      name: "Shree",
      category: "Cement",
      img: "/Images/shree.png",
    },
    {
      id: "3",
      name: "JK Super",
      category: "Cement",
      description: "Strong and reliable cement brand",
      img: "/Images/jksuper.png",
    },
    {
      id: "4",
      name: "Ambuja",
      category: "Cement",
      img: "/Images/ambuja.png",
    },
    {
      id: "5",
      name: "ACC",
      category: "Cement",
      img: "/Images/acc.png",
    },
    {
      id: "6",
      name: "JSW",
      category: "Cement",
      img: "/Images/jsw.png",
    },
    {
      id: "7",
      name: "Steel",
      category: "Steel",
      img: "/Images/steelConst.jpg",
    },
    {
      id: "8",
      name: "Construction Machinery",
      category: "Machinery",
      img: "/Images/machineryImg.jpg",
    },
  ];

  // Load products on mount
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setProducts(hardcodedProducts);
      setFilteredProducts(hardcodedProducts);
      setLoading(false);
    }, 500);
  }, []);

  // Filter products based on category and search
  useEffect(() => {
    const filtered = products.filter((product) => {
      const name = product.name?.toLowerCase() || "";
      const category = product.category?.toLowerCase() || "";
      const matchesCategory =
        selectedCategory === "all" || category === selectedCategory.toLowerCase();
      const matchesSearch = name.includes(searchTerm.toLowerCase());
      return matchesCategory && matchesSearch;
    });
    setFilteredProducts(filtered);
  }, [products, selectedCategory, searchTerm]);

  // Generate categories dynamically from products
  const categories = [
    { id: "all", name: "All Products", count: products.length },
    ...Array.from(new Set(products.map((p) => p.category)))
      .filter(Boolean)
      .map((category) => ({
        id: category.toLowerCase(),
        name: category,
        count: products.filter(
          (p) => p.category?.toLowerCase() === category.toLowerCase()
        ).length,
      })),
  ];

  // Handle navigation based on product category
  const handleOrderNow = (product) => {
    if (product.category.toLowerCase() === "steel") {
      navigate("/dashboard/steel-order-form", { state: { product } });
    } else if (product.category.toLowerCase() === "machinery") {
      navigate("/dashboard/machinery-order-form", { state: { product } });
    } else {
      // Default: Cement or any other → use main product order form
      navigate("/dashboard/product-order-form", { state: { product } });
    }
  };

  const neworderAlarm = () => {
    alert(
      "Welcome to the Product Catalog!\n\n" +
        "- Browse available products\n" +
        "- Filter by categories\n" +
        "- Click 'Order Now' to place your order"
    );
  };

  if (loading) {
    return (
      <div className="new-loading-container">
        <div className="new-loader"></div>
      </div>
    );
  }

  return (
    <div className="container-fluid new-order-container">
      <div className="header">
        <h1 className="page-title text-center">
          Construction Materials{" "}
          <MdInfo className="icon-i" onClick={neworderAlarm} />
        </h1>
      </div>

      <div className="content">
        {/* Sidebar with Categories */}
        <div className="sidebar">
          <div className="sidebar-header">
            <h2>Categories</h2>
          </div>
          <div className="category-list">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`category-button fw-bold ${
                  selectedCategory === category.id ? "active" : ""
                }`}
              >
                <span className="category-name">
                  {selectedCategory === category.id && (
                    <span className="category-indicator">›</span>
                  )}
                  {category.name}
                </span>
                <span className="category-count">{category.count}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Product Grid */}
        <div className="product-grid-container">
          {filteredProducts.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🛒</div>
              <h3 className="empty-title">No products found</h3>
              <p>Try changing your filter or search</p>
            </div>
          ) : (
            <div className="product-grid">
              {filteredProducts.map((product) => (
                <div key={product.id} className="Mypcontainer">
                  <div className="product-image-container">
                    <img
                      src={product.img || "/placeholder.svg"}
                      alt={product.name}
                      className="product-image"
                      onError={(e) => (e.target.src = "/placeholder.svg")}
                    />
                  </div>
                  <div className="product-details">
                    <div className="product-header">
                      <h3 className="product-name">{product.name}</h3>
                      {product.category && (
                        <span className="product-category-badge">
                          {product.category}
                        </span>
                      )}
                    </div>
                    {/* <p className="product-description">
                      {product.description || "High-quality construction product"}
                    </p> */}
                    <button
                      onClick={() => handleOrderNow(product)}
                      className="product-button"
                    >
                      Order Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewOrder;